import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { useQuery } from "../../../hooks/useQuery";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";

const CompteActivationPage = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const url = useQuery();

  const handleResendActivationLink = () => {
    setloading(true);
    showToast(TYPE_NOTIFICATION.INFO, "Envoi du lien d'activation...");
    AuthService.resendActivationLink({ uuid: url.get("ref") })
      .then((res) => {
        if (res && res.success) {
          showNotification(
            "Information",
            res.message,
            TYPE_NOTIFICATION.INFO,
            () => {
              navigate("/login");
            }
          );
        } else {
          handleShowNotificationResendLink(
            res.message,
            handleResendActivationLink
          );
        }
      })
      .finally(() => {
        setloading(false);
      });
  };

  const handleShowNotificationResendLink = (message, handleClickButton) => {
    showNotification(
      "Erreur",
      <Grid>
        {message}
        <br />
        <LoadingButton
          loading={loading}
          variant="contained"
          color="primary"
          size="small"
          onClick={handleClickButton || handleResendActivationLink}
        >
          Demander un nouveau lien
        </LoadingButton>
      </Grid>,
      TYPE_NOTIFICATION.ERROR,
      () => {
        navigate("/login");
      },
      "Fermer"
    );
  };

  const handleCheckToken = () => {
    setloading(true);
    const authData = {
      uuid: url.get("ref"),
      token: url.get("token"),
    };
    if (
      Object.values(authData).some((value) => value === "" || value === null)
    ) {
      showNotification(
        "Information incomplete",
        "Veuillez utiliser le lien foruni via l'email",
        TYPE_NOTIFICATION.ERROR,
        () => {
          navigate("/login");
        },
        "Continuer avec la page d'authentification"
      );
      setloading(false);
      return;
    }
    AuthService.activateAccount(authData)
      .then((res) => {
        if (res && res.success) {
          showNotification(
            "Compte activé avec succès",
            res.message,
            TYPE_NOTIFICATION.SUCCESS,
            () => {
              navigate("/login");
            },
            "Continuer avec la page d'authentification"
          );
        } else {
          handleShowNotificationResendLink(
            res.message,
            handleResendActivationLink
          );
        }
      })
      .finally(() => {
        setloading(false);
      });
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    } else {
      handleCheckToken();
    }
  }, []);

  return (
    <>
      <NotificationComponent />
      <Toast />
    </>
  );
};

export default CompteActivationPage;
